import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


import UploadButton from '@/components/ui/buttons/UploadButton';

export type AddFileConfirmationDialogProps = {
    open: boolean;
    onUpload?: (file: File) => void
    onClose: () => void;
};

function AddFileConfirmationDialog(props: AddFileConfirmationDialogProps) {
    const { open, onUpload, onClose } = props;
    const { t } = useTranslation();


    return (
        <Dialog onClose={onClose} maxWidth="sm" open={open} PaperProps={{ sx: { minWidth: '500px' } }}>
            <DialogTitle>
                <Stack alignItems="center" spacing={2}>
                    <Typography variant="h6" component="div" sx={{ fontSize: '24px', textAlign: 'center' }}>
                        {t('page.admin.logo.title.label')}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <UploadButton onUpload={onUpload} />
            </DialogContent>
            <DialogActions sx={{ p: '0 24px 16px' }}>
                <Button variant="neutral" onClick={onClose}>
                    {t('common:button.cancel.label')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddFileConfirmationDialog;
